import React, { Component } from 'react';
import { Checkbox, MenuItem } from '@mui/material';

export default class CheckboxField extends Component {
    handleChange = () => {
        this.props.onChange(this.props.fieldDef.fieldId, !this.props.value);
    };

    render() {
        const { fieldDef, value, disabled } = this.props;

        return (
            <div className="form-group">
                <MenuItem onClick={this.handleChange} disabled={disabled}>
                    <Checkbox checked={value || false} />
                    {fieldDef.label}
                </MenuItem>
            </div>
        );
    }
}
